import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

import { PageName } from 'src/app/shared/utils/user-roles';
import { IUser } from '../../user-management-interfaces';
import { Utility } from 'src/app/shared/utils/utility.service';
import {
  IUserGroup,
  IUserGroups,
} from '../../add-user/add-user-management.interface';
import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-multi-user-type',
  templateUrl: './multi-user-type.component.html',
  styleUrls: ['./multi-user-type.component.scss'],
})
export class MultiUserTypeComponent implements OnInit {
  formGroup!: FormGroup;
  submited = false;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() userType!: any;
  @Output() userTypeChange = new EventEmitter<any>();
  @Output() submitToParent = new EventEmitter<any>();
  flag = false;
  @Input() disableUpperRoles: boolean = true;
  commonAccessControl!: boolean;

  user: IUser | undefined;
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  navigateFlag = false;
  radionButtons: IUserGroups = [
    {
      label: this.translate.instant('PROPERTY_MANAGER_ADMIN'),
      name: 'group',
      value: 1,
      desc: this.translate.instant('DESCRIPTION_PROPERTY_MANAGER_ADMIN'),
      active: false,
      disabled: false,
    },
    {
      label: this.translate.instant('PROPERTY_MANAGER_USER'),
      name: 'group',
      value: 2,
      desc: this.translate.instant('DESCRIPTION_PROPERTY_MANAGER_USER'),
      active: false,
      disabled: false,
    },
    {
      label: this.translate.instant('INSTALLER_ADMIN'),
      name: 'group',
      value: 3,
      desc: this.translate.instant('DESCRIPTION_INSTALLER_ADMIN'),
      active: false,
      disabled: false,
    },
    {
      label: this.translate.instant('INSTALLER_USER'),
      name: 'group',
      value: 4,
      desc: this.translate.instant('DESCRIPTION_INSTALLER_USER'),
      active: false,
      disabled: false,
    },
    {
      label: this.translate.instant('RESIDENT_ADMIN'),
      name: 'group',
      value: 5,
      desc: this.translate.instant('DESCRIPTION_RESIDENT_ADMIN'),
      active: false,
      disabled: false,
    },
    {
      label: this.translate.instant('RESIDENT'),
      name: 'group',
      value: 6,
      desc: this.translate.instant('DESCRIPTION_RESIDENT'),
      active: false,
      disabled: false,
    },
  ];

  constructor(
    private fb: FormBuilder,
    public stateManagementService: StateManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  get formInstance() {
    return this.formGroup.controls;
  }
  /**
   * @description this is onInit life cycle method
   * get formgroup from parent with the help of formgroupdirective
   * @returns void
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.user = this.stateManagementService.getUser();
    this.commonAccessControl =
      this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    /** check current user type Property_Manager_User  */
    if (this.user.userType! === userTypeResponse[2]) {
      this.radionButtons!.splice(0, 2); // this remove start two user type
    }

    this.formGroup = this.fb.group({
      userType: [this.userType, MFValidators.compose([MFValidators.required])],
    });

    this.radionButtons!.map((userGroup: IUserGroup) => {
      if (userGroup.value === this.formInstance?.userType.value) {
        userGroup.active = true;
      }
    });

    if (this.disableUpperRoles) {
      this.radionButtons?.map((userGroup: IUserGroup) => {
        if (userGroup.label.includes(CONSTANTS.RESIDENT)) {
          userGroup.disabled = false;
        } else {
          userGroup.disabled = true;
        }
      });
    }
  }

  /**
   * @description current selected group index mark as active status
   * @param userGroup active number
   */
  activate(userGroup: IUserGroup): void {
    if (!userGroup.disabled) {
      this.radionButtons?.map((x: IUserGroup) => {
        x.active = false;
        userGroup.active = true;
        this.formGroup.get('userType')?.setValue(userGroup.value);
        this.userTypeChange?.emit(this.formInstance?.userType.value);
      });
    }
  }

  /**
   * @description navigate to back stepper
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }

  /**
   * @description validate from if form valid redirect to next step
   * @returns void
   */
  submit(): void {
    this.flag = false;
    if (this.formGroup.invalid) return;
    if (!this.commonAccessControl) {
      let userDetail: any = {};
      userDetail.startTime = CONSTANTS.NOW;
      this.submitToParent?.emit(userDetail);
    } else {
      this.stepperChange.emit((this.stepper += 1));
    }
  }
}
